/* eslint-disable max-lines */
import styled from 'styled-components';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import H6 from '@base/H6/H6';
import { Spacings, TextColors } from '@styles/index';

const Left = styled.div`
  grid-column: 1/6;
  position: fixed;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Right = styled.div`
  grid-column: 6/25;
  @media (max-width: 768px) {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const PrivacyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const H1Container = styled.div`
  margin-top: ${Spacings.SPACING_2B};
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const StyledAnchor = styled.a`
  color: ${TextColors.BLUE};
  margin-left: ${Spacings.SPACING_1B};
`;

const tableData = [
  { label: 'A. General', id: 'general' },
  { label: 'B. Applicability', id: 'applicability' },
  { label: 'C. Access', id: 'access' },
  { label: 'D. Personal Information', id: 'personal_information' },
  {
    label: 'E. Automatic Information Collection',
    id: 'information_collection'
  },
  { label: 'F. Information Security', id: 'information_security' },
  { label: 'G. Use of your personal information', id: 'use_personal_info' },
  { label: 'H. Exceptions', id: 'exceptions' }
];

const Privacy = () => {
  const router = useRouter();
  const { pathname, query } = router;

  return (
    <>
      <Left>
        <MenusNav data={menus} currentHref={pathname} />
      </Left>

      <Right>
        <PrivacyWrapper>
          <div>
            {query.in_app !== 'true' && (
              <H1Container>
                <H2>Privacy policy</H2>
              </H1Container>
            )}
            <br />
            <div>
              <article>
                <br />
                <ContentsTable data={tableData} />
                <a name="general">
                  <StyledH3>A. General</StyledH3>
                </a>
                <P1>
                  In this policy, the words &quot;we&quot;, &quot;our&quot;, and
                  &quot;us&quot; refer to Unacademy and the privacy mechanism
                  outlined identify personally identifiable or personal
                  information that may be collected, how such information is
                  used, and the choices You have regarding our use of this
                  information.
                </P1>
                <br />
                <P1>
                  In addition to the terms stated in Terms of Service provided
                  under this Website/mobile application (together “Platform”),
                  we are committed to protecting Your privacy. Only authorized
                  representatives of Unacademy and on a need to know basis only
                  use any information received from You and as consented by You.
                  We constantly review our systems and data to secure Your
                  personal information. In the event of any identified
                  unauthorized use or disclosure of information or upon Your
                  complaint, we will investigate any such complaint or such
                  actions with a view to prosecuting and/or taking civil
                  proceedings to recover damages against those responsible. Any
                  User who does not agree with any provisions of this Privacy
                  Policy and the Terms of Service is required to leave the
                  Platform immediately. Should You disagree with this Policy
                  (defined below) and still continue to access the Platform and
                  provide Your personal information, Unacademy disclaim all the
                  liabilities arising therefrom and it shall be assumed by Your
                  continued use of the Platform that You have accepted the
                  Policy and any other online terms and conditions available on
                  the Platform.
                </P1>
                <br />
                <P1>
                  If any information You have provided or uploaded on the
                  Platform violates the terms of this Policy, Unacademy may be
                  required to delete such information upon informing You of the
                  same and revoke Your access if required without incurring any
                  liability to You.
                </P1>
                <br />
                <br />

                <a name="applicability">
                  <StyledH3>B. Applicability</StyledH3>
                </a>

                <P1>
                  This privacy policy (“Policy”) applies to all Users who access
                  the Platform and are therefore required to read and understand
                  the Policy before submitting any Personal Information (defined
                  hereinafter). By submitting Personal Information, You are
                  consenting to the use and processing of such information in
                  accordance with this Policy. If You have inadvertently
                  submitted any Personal Information to Unacademy prior to
                  reading the Policy statements set out herein, or You do not
                  agree with the manner in which the Personal Information is
                  collected, stored or used, then You may access, modify and
                  delete all information stored about You by writing to us at
                  <StyledAnchor href="mailto:help@unacademy.com">
                    help@unacademy.com
                  </StyledAnchor>
                  . Unacademy is keeping personal data of the User, and every
                  User is also entitled to require Unacademy to delete and
                  destroy all such information (but not that of other Users).
                </P1>

                <P1>
                  This Policy applies to the Platform and any other services
                  that are owned and operated by Unacademy. Third party websites
                  may place their own cookies or other files on the Users&apos;
                  computer, collect data or solicit personal information from
                  the Users, for which Unacademy is not responsible or liable.
                  Accordingly, Unacademy does not make any representations
                  concerning the privacy practices or policies of such third
                  parties or terms of use of such websites, nor does Unacademy
                  guarantee the accuracy, integrity, or quality of the
                  information, data, text, software, sound, photographs,
                  graphics, videos, messages or other materials available on
                  such websites. The inclusion or exclusion does not imply any
                  endorsement by Unacademy of the website, the website&apos;s
                  provider, or the information on the website. Unacademy
                  encourages the User to read the privacy policies of each such
                  website and the User understands that its solely such third
                  party who is responsible to the User in this regard.
                </P1>
                <P1>
                  Unacademy has taken reasonable precautions as per applicable
                  Indian law and implemented industry standards to treat
                  Personal Information as confidential and to protect it from
                  unauthorized access, improper use or disclosure, modification
                  and unlawful destruction or accidental loss of the Personal
                  Information.
                </P1>

                <br />
                <br />

                <a name="access">
                  <StyledH3>C. Access</StyledH3>
                </a>

                <P1>
                  User are allowed to access the Platform, register for courses
                  and avail services available with Unacademy as a guest and
                  without creating an account on the Platform or providing any
                  Personal Information, Unacademy takes no responsibility or
                  validate the information provided by the guest, except as
                  otherwise required under any law, regulation or an order of
                  competent authority. In order to have access to all the
                  features and benefits on our Platform, a User is required to
                  first create an account on our Platform. To create an account,
                  a User is required to provide Personal Information as may be
                  required during the time of registration. Other information
                  requested on the registration page, including the ability to
                  receive promotional offers from Unacademy, is optional.
                  Unacademy may, in future, include other optional requests for
                  information from the User to help Unacademy to customize the
                  Platform to deliver personalized information to the User.
                  Without User&apos;s agreement, Unacademy will not share, rent
                  or sell any Personal Information with third parties in any way
                  other than what is disclosed in this Policy. Unacademy may
                  keep records of telephone calls received and made for making
                  enquiries, registered courses, feedback or other purposes for
                  the purpose of rendering services effectively and efficiently.
                </P1>
                <br />
                <br />

                <a name="personal_information">
                  <StyledH3>D. Personal Information</StyledH3>
                </a>

                <P1>
                  “Personal Information” shall mean the information which
                  identifies the User, name, identification number, email
                  address, age, gender, or phone number provided to Unacademy at
                  the time of registration or any time thereafter. Personal
                  information may include “sensitive personal information or
                  data” as defined under the Information Technology (Reasonable
                  Security Practices and Procedures and Sensitive Personal Data
                  or Information) Rules, 2011 and in this context, includes
                  passwords or any financial account information provided by You
                  during registration.
                </P1>
                <P1>
                  We request You to not provide us with any Personal Information
                  unless specifically requested by us. In such events, we bear
                  no liability to such Personal Information provided by You.
                </P1>
                <br />
                <br />

                <a name="information_collection">
                  <StyledH3>E. Automatic Information Collection</StyledH3>
                </a>

                <P1>
                  Our system collects information that is sent over the internet
                  without Your control. Some examples of the information we
                  collect and analyse include the Internet protocol (IP) address
                  used to connect Your computer to the internet; login; email;
                  password; computer and connection information such as browser
                  type and version, operating system, and platform; course
                  enrolled history, which we sometimes aggregate with similar
                  information from other users to create features, reports such
                  as popular courses, most used features etc; the full Uniform
                  Resource Locator (URL) click stream to, and from our Platform,
                  including date and time; cookie number; courses or videos You
                  viewed or searched for; the email id You used to call our
                  customer service.
                </P1>
                <P1>
                  During some visits we may use software tools such as
                  JavaScript to measure and collect session information,
                  including page response times, download errors, length of
                  visits to certain page, course and videos, page interaction
                  information (such as scrolling, clicks and mouse overs), and
                  methods used to browse away from the page.
                </P1>
                <br />
                <br />

                <a name="information_security">
                  <StyledH3>F. Information Security</StyledH3>
                </a>

                <P1>
                  To protect the security of Your Personal information during
                  transmission, we use Secure Sockets Layer (SSL) software,
                  which encrypts information You input. To prevent unauthorized
                  access to sensitive information, it is important for You to
                  monitor those who have access to Your password and to Your
                  computer, laptop or any other device through which Your
                  account can be accessed. Be sure to sign off when finished
                  while using a shared computer.
                </P1>
                <P1>
                  However, please do note that given the nature of internet
                  transactions, Unacademy does not take any responsibility for
                  the transmission of information including Personal Information
                  shared by You other than as set forth in this Policy. Any
                  transmission of information on the internet is done at Your
                  risk and shall not be responsible for the circumvention of the
                  privacy settings or security measures either by You or any
                  third-party.
                </P1>
                <br />
                <br />

                <a name="use_personal_info">
                  <StyledH3>G. Use of your personal information</StyledH3>
                </a>

                <P1>
                  While availing our services You will provide access to
                  Unacademy with Your Personal Information. If that information
                  is wrong, You can request us to modify or delete the same.
                  Unacademy will take all reasonable measures to ensure that the
                  Personal Information is modified and used for rendering
                  services to You and as otherwise in compliance with laws. When
                  editing or deleting Personal Information, we may ask You to
                  verify Your identity before we can act on Your request.
                  Unacademy may at its discretion reject any request that is
                  contrary to law, requires un-reasonable technical efforts. We
                  do not assure that we will delete all residual copies and
                  archives made by any third party without our knowledge and
                  consent. We never retain Your Personal Information longer than
                  it is required for the purposes of providing services through
                  the Platform or as required by applicable Indian law. At
                  times, we may also require to transfer Your Personal
                  Information to third-party service providers, for instance to
                  authorize transactions we may share Your financial data with
                  such third-party providers. You hereby consent to Your
                  transfer of Personal Information in all such instances.
                  Unacademy carries out all such transfers strictly in
                  accordance with law.
                </P1>

                <P1>
                  Unacademy shall use Your Personal Information to ensure
                  services with respect to the Platform are presented to You in
                  the most effective manner, to secure the Platform and make
                  improvements, to carry out our obligations to You, and to
                  communicate with You. The said communication can either be by
                  calls, text or emails and for purposes which include
                  transactional, service, or promotional calls or messages. If
                  at any time You wish to not receive any communication from our
                  end You can opt-out of the same by writing to us on
                  <StyledAnchor href="mailto:help@unacademy.com">
                    help@unacademy.com
                  </StyledAnchor>
                  .
                </P1>

                <br />
                <br />

                <a name="exceptions">
                  <StyledH3>H. Exceptions</StyledH3>
                </a>

                <P1>
                  Your Personal Information may be shared with third parties who
                  have a need or authority to receive such information, if we
                  have a good-faith belief that access, use, preservation or
                  disclosure of the information is reasonably necessary to
                  comply with (i) in response to any authority having to receive
                  such information under law (ii) any order of court (iii)
                  detect, prevent, or otherwise address fraud, security or
                  technical issues (iv) protect against harm to the rights,
                  property or safety of Unacademy, our users or the public as
                  required or permitted by law.
                </P1>
                <br />
                <br />

                <StyledH3>
                  User choices with regard to access of information
                </StyledH3>

                <P1>
                  Unacademy does not make any unsolicited calls or otherwise
                  market any products or services, except for in relation to the
                  purpose for which such information has been provided or taking
                  any feedback, addressing any complaints, informing You about
                  new features or free/paid courses. User shall not disclose
                  their Personal Information to any third parties that is not
                  authorised by Unacademy and verify the identity of such person
                  who seek information. Unacademy will communicate with the
                  Users through call, SMS, email or notices posted on the
                  Platform or through any other means available, which shall
                  include but not be limited to text, other forms of messaging,
                  calls etc. The Users can change their e-mail and contact
                  preferences at any time by logging into their account or by
                  emailing at
                  <StyledAnchor href="mailto:help@unacademy.com">
                    help@unacademy.com
                  </StyledAnchor>
                  .
                </P1>
                <P1>
                  Unacademy may, if You so choose, send direct mailers to You at
                  the address given by You. You have the option to
                  &apos;opt-out&apos; of this direct mailer by way of links
                  provided at the bottom of each mailer. We respect Your privacy
                  and to the extent that You choose not to receive such mailers,
                  we will take all steps to remove You from the list. Should You
                  evidence any violation of our terms and policies, please write
                  to us at
                  <StyledAnchor href="mailto:help@unacademy.com">
                    help@unacademy.com
                  </StyledAnchor>
                  and report such incident.
                </P1>
                <P1>
                  All the information provided to Unacademy by You, You as a
                  User confirms that the same including sensitive Personal
                  Information, is true, accurate and voluntary. User has the
                  right to withdraw information at any time, in accordance with
                  the terms of this Policy and the Terms of Service.
                </P1>
                <br />
                <br />

                <StyledH3>Report, Analysis &amp; Confidentiality</StyledH3>

                <P1>
                  Unacademy may have to use Personal Information without
                  reference to any persona or identity for research, statistical
                  analysis improving the Platform of functionalities offered
                  thereon and business intelligence purpose and may transfer
                  such research, statistical or intelligence data in an
                  aggregated or non-personally identifiable form to third
                  parties and affiliates.
                </P1>
                <P1>
                  All Unacademy employees and data processors, who have access
                  to, and are associated with the processing of sensitive
                  personal data or information, are obliged to respect the
                  confidentiality of every User&apos;s sensitive personal data
                  and information.
                </P1>
                <br />
                <br />

                <StyledH3>Sharing of Information</StyledH3>

                <P1>
                  Unacademy may also disclose or transfer User&apos;s personal
                  and other information which a User provides, to another third
                  party as part of reorganization or a sale of the assets of
                  Unacademy corporation division or company. Any third party to
                  which Unacademy transfers or sells its assets will have the
                  right to continue to use the personal and other information
                  that a User provide to us.
                </P1>
                <P1>
                  To the extent necessary to provide Users with the services on
                  the Platform, Unacademy may provide User’s Personal
                  Information to third party contractors who work on behalf of
                  or with Unacademy to provide Users with such services, to help
                  Unacademy communicate with Users or to maintain the Platform.
                  Generally, these contractors do not have any independent right
                  to share this information, however certain contractors who
                  provide services on the Platform, including the providers of
                  online communications services, online payment gateway
                  services, will have rights to use and disclose the Personal
                  Information collected in connection with the provision of
                  these services in accordance with their own privacy policies.
                </P1>
                <P1>
                  Furthermore, please note that we cannot control the actions of
                  other Users of the Platform with whom You may choose to share
                  Your Personal Information, and any such actions on Your behalf
                  shall be solely Your responsibility.
                </P1>
                <br />
                <br />
                <StyledH3>Interest-Based Ads</StyledH3>
                <P1>
                  On unaffiliated sites, Unacademy may display interest-based
                  advertising using information You make available to us when
                  You interact with our Platform, content, or services.
                  Interest-based ads, also sometimes referred to as personalised
                  or targeted ads, are displayed to You based on information
                  from activities such as subscription on our Platform, visiting
                  sites that contain Unacademy content or ads. In providing
                  interest-based ads, we follow applicable Indian laws, as well
                  as the Code for Self-Regulation in Advertising by the
                  Advertising Standards Council of India and the Self-Regulatory
                  Principles for Online Behavioral Advertising developed by the
                  Digital Advertising Alliance (a coalition of marketing, online
                  advertising, and consumer advocacy organizations).
                </P1>
                <P1>
                  Like other online ad networks, we use cookies, web beacons
                  (also known as action tags or single-pixel gifs), and other
                  technologies (collectively, “cookies”). Cookies enable us to
                  learn about what ads You see, what ads You click, and other
                  actions You take on our sites and other sites. This allows us
                  to provide You with more useful and relevant ads. For example,
                  if we know what ads You are shown we can be careful not to
                  show You the same ones repeatedly. We do not associate Your
                  interaction with unaffiliated sites with Your identity in
                  providing You with interest-based ads.
                </P1>
                <P1>
                  We do not provide any personal information to advertisers or
                  to third party sites that display our interest-based ads.
                  However, advertisers and other third-parties (including the ad
                  networks, ad-serving companies, and other service providers
                  they may use) may assume that users who interact with or click
                  on a personalised ad or content are part of the group that the
                  ad or content is directed towards (for example, users in
                  eastern India who bought or browsed for literature books).
                  Also, some third-parties may provide us information about You
                  (such as the sites where You have been shown ads or
                  demographic information) from offline and online sources that
                  we may use to provide You more relevant and useful
                  advertising.
                </P1>
                <P1>
                  Advertisers or ad companies working on their behalf sometimes
                  use technology to serve the ads that appear on our sites
                  directly to Your browser. They automatically receive Your IP
                  address when this happens. They may also use cookies to
                  measure the effectiveness of their ads and to personalise ad
                  content. We do not have access to or control over cookies or
                  other features that advertisers and third party sites may use,
                  and the information practices of these advertisers and third
                  party websites are not covered by our Policy. Please contact
                  them directly for more information about their privacy
                  practices.
                </P1>
                <br />
                <br />

                <StyledH3>Revision of terms &amp; Grievance reporting</StyledH3>

                <P1>
                  Unacademy may update or amend this Policy at any time, with or
                  without advance notice. In the event there are significant
                  changes in the way Unacademy treats User&apos;s personally
                  identifiable information, Unacademy will display a notice on
                  the Platform or send Users an email. Unacademy&apos;s current
                  Policy to all information that Unacademy has about Users and
                  their account.
                </P1>
                <P1>
                  Notwithstanding the above, Unacademy shall not be required to
                  notify the Users of any changes made to the privacy policy.
                  Should You have any concern or reject the changes in the
                  privacy policy You can refuse to accept the amendments and opt
                  for withdrawing Your Personal Information by writing to us at
                  <StyledAnchor href="mailto:help@unacademy.com">
                    help@unacademy.com
                  </StyledAnchor>
                  .
                </P1>
                <P1>
                  If You have any compliant or grievances with respect to
                  Website or Privacy Policy, please contact our Grievance
                  Officer.
                </P1>
                <br />
                <br />
                <H6>Grievance Officer Details – </H6>
                <P1>Name: Denise Gardner</P1>
                <P1>
                  Contact:
                  <StyledAnchor href="mailto:legal@unacademy.com">
                    legal@unacademy.com
                  </StyledAnchor>
                </P1>
              </article>
            </div>
            <br />
            <br />
          </div>
        </PrivacyWrapper>
      </Right>
    </>
  );
};

Privacy.pageInfo = {
  name: 'Unacademy Privacy',
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default Privacy;
